<template>
  <div class="pixelated supply-drop _ship" style="border: 1px solid #ddd; border-top: none; position: relative; width: 361px; height: 361px; overflow: hidden; flex-basis: 361px; flex-shrink: 0" :style="state === STATE_CRATE_LANDING && ! hasConfirmedDrop ? 'cursor: pointer' : null" @click="openCrate">
    <template v-if="state === STATE_CRATE_LANDING">
      <div class="ap-fill" :style="avatarBackgroundStyle" />
      <div class="ap-fill" style="background-repeat: no-repeat; background-position: top left; background-image: url(/img/member/supply-drop/ship/supply_levelup_brygga_ship.gif)" />
      <div class="ap-fill no-repeat"
      style="background-position: bottom left;
      background-image: url('/img/member/supply-drop/ship/supply_levelup_brygga.png');" />
      <div class="ap-fill flat-crate pixelated" :style="{ backgroundSize: 'contain', backgroundImage: 'url(' + sprites.flatCrate.src + ')' }" v-if="showItem" />

      <open-result-showcase v-if="showItem" :drops="newDrops" />

      <canvas width="361" height="361" ref="dropCanvas" class="ap-tl pixelated" style="pointer-events: none;" />
    </template>
    <template v-else>
      <div id="sd_shipBackground" class="ap-fill" />
      <div id="sd_distantMountains" class="ap-fill" />
      <div
      :style="boatBackgroundStyle"
      class="ap-fill" />
      <canvas width="361" height="361" ref="dropCanvas" class="ap-fill pixelated" />
      <div id="sd_foregroundMountains" class="ap-fill" />
      <div v-if="xpCalculable" class="drop-countdown text-center">
        <div class="drop-countdown-header">NEXT RESUPPLY IN</div>
        <div class="drop-countdown-time">{{ timeToDrop }}</div>
      </div>
    </template>
  </div>
</template>

<style scoped>
.no-repeat {
  background-repeat: no-repeat;
}
</style>

<script>
import alert from 'alert';
import * as staticData from 'staticData';
import { formatNumber, convertToCdnUrl } from 'utils';

import openResultShowcase from './open-result-showcase.vue';

const STATE_COUNTDOWN = 0;
const STATE_DROPPING = 1;
const STATE_CRATE_LANDING = 2;
const STATE_CRATE = 3;

export default {
	components: {
		openResultShowcase,
	},
	data () {
		return {
			STATE_COUNTDOWN,
			STATE_DROPPING,
			STATE_CRATE_LANDING,
			STATE_CRATE,

			requestedDrop: false,

			timerInterval: null,
			renderInterval: null,
			timeToDrop: '',
			state: STATE_COUNTDOWN, // animationsstate
			showItem: false,

			sprites: {
				box: {
					img: null,
					frame: 0,
				},
				wave: null,
				flatCrate: {
					src: null,
				},
			},
			isOnCrateScreen: true,
			hasConfirmedDrop: false,
			waves: [],

			newDrops: [],
		};
	},
	props: ['nextDropTime', 'user', 'drops', 'crateType'],
	mounted () {
		const urlBase = '/img/member/supply-drop/ship/';

		let img = new Image();
		img.src = convertToCdnUrl(urlBase + 'skattkista.png');
		this.sprites.box.img = img;

		img = new Image();
		img.src = convertToCdnUrl(urlBase + 'crate_flat.png');
		this.sprites.flatCrate.src = img.src;

		img = new Image();
		img.src = convertToCdnUrl(urlBase + 'wave.png');
		this.sprites.wave = img;

		this.renderInterval = setInterval(this.renderDropCanvas.bind(this), 33);

		// seed the water with some waves
		for (let i = 0; i < 400; ++i) {
			if (Math.random() > 0.95) {
				this.spawnWave();
			}
			this.moveWaves();
		}

		const currentXp = this.user.experiencePoints;
		const xpToNextLevel = staticData.xpToNextRankLevel[this.user.rankLevel];
		const xpLeft = xpToNextLevel - currentXp;
		this.timeToDrop = formatNumber(xpLeft) + ' XP';
		if (xpLeft <= 0) {
			this.timeToDrop = 'Unlock more achievements to level up'; // @TODO visa antal
		}

		this.$nextTick(() => {
			this.$refs.dropCanvas.getContext('2d').imageSmoothingEnabled = false;
		});

		if (this.crateType.openableCount > 0) {
			this.timeToDrop = '3s';
			setTimeout(() => {
				this.timeToDrop = '2s';
			}, 1000);
			setTimeout(() => {
				this.timeToDrop = '1s';
			}, 2000);
			setTimeout(() => {
				this.state = STATE_CRATE_LANDING;
			}, 3000);
		}

	},
	beforeDestroy () {
		if (this.renderInterval) {
			clearInterval(this.renderInterval);
		}
	},
	computed: {
		avatarBackgroundStyle () {
			const backgroundImage = '/img/member/supply-drop/ship/supply_levelup_brygga_bg.gif';
			return {
				cursor: this.state === STATE_CRATE_LANDING ? 'pointer' : null,
				backgroundSize: 'cover',
				backgroundImage: 'url(' + convertToCdnUrl(backgroundImage) + ')',
			};
		},
		boatBackgroundStyle () {
			return `background: url(${convertToCdnUrl("/img/member/supply-drop/ship/supply_levelup_boat.gif")});
					background-repeat: no-repeat;
					background-size: contain;
					background-position: center;`
		},
		xpCalculable () {
			return staticData.xpToNextRankLevel[this.user.rankLevel];
		},
	},
	methods: {
		openCrate () {
			if (this.requestedDrop || this.sprites.box.frame < 5) {
				return;
			}
			if (this.crateType.openableCount === 0) {
				return;
			}

			this.requestedDrop = true;
			waja.post('supply-drop')
				.data({
					crateType: 'level-up',
				})
				.on('success', res => {
					this.$emit('open');
					this.hasConfirmedDrop = true;
					this.newDrops = res.data.drops;
				})
				.on('error', res => {
					// this.requestedDrop = false;
					if (res.status === 403) {
						alert('Du har redan öppnat denna låda!');
					} else {
						alert('Något gick fel :(');
					}
				}).go();
		},
		spawnWave () {
			const height = Math.random();
			this.waves.push({
				x: 361,
				y: 222 + (height * 160)|0,
				speed: 0.4 + 1.5 * height,
			});
		},
		moveWaves () {
			for (let i = 0; i < this.waves.length; ++i) {
				const wave = this.waves[i];
				wave.x -= wave.speed;
				if (wave.x <= -32) { // Hela vågen utanför skärmen
					this.waves.splice(i--, 1);
					continue;
				}
			}
		},
		renderDropCanvas () {
			const canvas = this.$refs.dropCanvas;
			if (! canvas) {
				console.error('no canvas ref!! :(');
				return;
			}
			const ctx = canvas.getContext('2d');
			ctx.clearRect(0, 0, canvas.width, canvas.height);

			const pWidth = 400;
			const pHeight = 165;

			const cWidth = 80;
			const cHeight = 80;
			const cTargetWidth = 400;
			const cTargetHeight = 400;

			if (this.state === STATE_COUNTDOWN) {
				if (Math.random() > 0.96) {
					this.spawnWave();
				}
				this.moveWaves();
				for (const wave of this.waves) {
					ctx.drawImage(this.sprites.wave, wave.x, wave.y);
				}
			} else if (this.state === STATE_CRATE_LANDING) {
				// update plane
				const spr = this.sprites.box;
				spr.frame += 0.25;
				if (spr.frame >= 5 && ! this.hasConfirmedDrop) {
					spr.frame = 5;
				} else if (spr.frame >= 13) {
					this.showItem = true;
				} else if (spr.frame >= 17) {
					if (this.renderInterval) {
						clearInterval(this.renderInterval);
						this.renderInterval = null;
					}
				}
				const f = Math.floor(spr.frame);
				ctx.drawImage(spr.img, (f % 5) * cWidth, Math.floor(f / 5) * cHeight, cWidth, cHeight, -16, 0, cTargetWidth, cTargetHeight);
			}
		},
	},
};
</script>
